module.exports = __webpack_public_path__ + "img/011.9259556c.png";